import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { Goal } from '@/core/interfaces';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService, UsersService } from '@/shared/services';
import { environment } from '../../../../environments/environment';
import { DropDownAnimation } from '../navbar/animations';
import { ToolListService } from '@/shared/services/tool-list.service';

@Component({
  selector: 'goal-card',
  templateUrl: './goal-card.component.html',
  styleUrls: ['./goal-card.component.css'],
  animations: [DropDownAnimation],
  standalone: false,
})
export class GoalCardComponent implements OnInit {
  @Input() goal!: Goal;
  @Input() showMoreInfoIcon!: boolean;

  currentRoute: string = '';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public router: Router,
    public authService: AuthService,
    public toolListService: ToolListService,
  ) {}

  ngOnInit(): void {
    this.currentRoute = this.router.url;

    // Listen to route changes
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  isActive(toolUrl: string) {
    return this.authService.hasPermission(toolUrl, true);
  }

  hideCard() {
    this.toolListService.setToolHiddenFlag(this.goal, true);
  }

  navigateToHelpPage() {
    this.router.navigateByUrl(this.goal.help_url);
  }

  // function to navigate user to tools page
  navigate(toolUrl: string, toolPermission: string) {
    // default Shiny app link
    if (!this.isActive(toolPermission)) return;

    let baseUrl = '';
    if (isPlatformBrowser(this.platformId)) {
      const parsedUrl = new URL(window.location.href);
      baseUrl = parsedUrl.origin;
    }
    var link: string = `${baseUrl}/${environment['shiny_url']}`;

    // if link is an external page then open a new window to that page
    // else navigate user to the chosen tool page
    if (toolUrl.includes('&tabname=') && isPlatformBrowser(this.platformId)) {
      const url = `${link}/?auth=${localStorage.getItem('token')}${toolUrl}`;
      window.open(url);
    } else {
      this.router.navigateByUrl(toolUrl);
    }
  }
}
